import { createBrowserRouter } from "react-router-dom";
import HomeView from "../views/HomePage";
import App from "../App";
import ProjectXView from "../views/ProjectXView";
import AboutView from "../views/AboutView";
import BlogView from "../views/BlogView";
import TeamView from "../views/TeamView";
import ContactUsView from "../views/ContactUsView";

export enum ROUTES {
    ROOT = "/",
}

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "/",
                element: <HomeView />,
            },
            {
                path: "/project-x",
                element: <ProjectXView />,
            },
            {
                path: "/about",
                element: <AboutView />,
            },
            {
                path: "/blog",
                element: <BlogView />,
            },
            {
                path: "/team",
                element: <TeamView />,
            },
            {
                path: "/contact-us",
                element: <ContactUsView />,
            },
        ],
    },
]);

export default router;
